// One-shot guard shared by the two silent-renewal paths (AuthGuard +
// withReauthFallback). A prompt=none redirect either returns a fresh code or
// comes back with ?error=login_required; this flag survives that navigation so
// the second pass escalates to interactive login instead of looping forever.
// sessionStorage scopes it to the tab and clears on close.
const KEY = "appretio.silent_reauth_attempted";

/** True if a silent (prompt=none) re-auth has already been tried this session. */
export function silentReauthAlreadyTried(): boolean {
  return sessionStorage.getItem(KEY) === "true";
}

/** Mark that a silent re-auth is being attempted (before redirecting away). */
export function markSilentReauthTried(): void {
  sessionStorage.setItem(KEY, "true");
}

/** Reset the guard once a real token is obtained or interactive login starts. */
export function clearSilentReauth(): void {
  sessionStorage.removeItem(KEY);
}
